import taskPieTemplate from './taskspie.html';
import 'angular-google-chart';

angular.module('org.saga.taskspie', [
   'googlechart',
   'org.saga.graphmenu'
])

   .directive('tasksPie', function() {
      return {
         restrict: 'E',
         transclude: true,
         template: taskPieTemplate,
         controllerAs: 'ctrl',
         scope: {
            ngModel: '=',
            height: '@'
         },
         controller: ['$scope', '$location', '$translate', function($scope, $location, $translate) {

            $scope.myChartObject = {};

            $scope.myChartObject.type = 'PieChart';

            $scope.myChartObject.data = {
               'cols': [
                  { type: 'string', id: 't', label: $translate.instant('Task Name') },
                  { type: 'number', id: 'c', label: $translate.instant('Count') }
               ],
               'rows': []
            };

            $scope.myChartObject.options = {
               title: null
            };

            $scope.setGraph = function(model) {
               $scope.myChartObject.data.rows = [];
               angular.forEach(model, function(value, key) {
                  var slice = {
                     c: [
                        { v: key },
                        { v: value }
                     ]
                  };
                  $scope.myChartObject.data.rows.push(slice);
               });
            };

            $scope.$watch('ngModel', function(model) {
               $scope.setGraph(model);
            });

         }]
      };
   });
